"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Loading = function Loading(_ref) {
  var _tour$additionalData;

  var tour = _ref.tour,
      train = _ref.train,
      isLoadingCoupledAssets = _ref.isLoadingCoupledAssets;

  var _ref2 = (_tour$additionalData = tour.additionalData) !== null && _tour$additionalData !== void 0 ? _tour$additionalData : {},
      _ref2$railInfo = _ref2.railInfo,
      railInfo = _ref2$railInfo === void 0 ? {} : _ref2$railInfo;

  var _railInfo$wagonLoadin = railInfo.wagonLoadings,
      wagonLoadings = _railInfo$wagonLoadin === void 0 ? [] : _railInfo$wagonLoadin;
  var name = train.name,
      _train$coupledAssets = train.coupledAssets,
      coupledAssets = _train$coupledAssets === void 0 ? [] : _train$coupledAssets;
  var sortArray = wagonLoadings.map(function (wagon) {
    return wagon.assetId;
  });
  coupledAssets.sort(function (a, b) {
    return sortArray.indexOf(a.id) - sortArray.indexOf(b.id);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-2"
  }, (0, _mapping.isCoupledAsset)(train.type) && name && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.loading.trainName"
  }), ': '), name), isLoadingCoupledAssets ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : coupledAssets.map(function (coupledAsset) {
    var _wagonLoadings$find;

    var wagonLoading = (_wagonLoadings$find = wagonLoadings.find(function (wagon) {
      return wagon.assetId === coupledAsset.id;
    })) !== null && _wagonLoadings$find !== void 0 ? _wagonLoadings$find : {};
    var _wagonLoading$weight = wagonLoading.weight,
        weight = _wagonLoading$weight === void 0 ? null : _wagonLoading$weight,
        _wagonLoading$nhmCode = wagonLoading.nhmCode,
        nhmCode = _wagonLoading$nhmCode === void 0 ? null : _wagonLoading$nhmCode,
        _wagonLoading$product = wagonLoading.productDescription,
        productDescription = _wagonLoading$product === void 0 ? null : _wagonLoading$product;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-4"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.loading.asset"
    }), ': '), coupledAsset.name), weight ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.loading.weight"
    }), ': '), weight) : null, nhmCode ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.loading.nhmCode"
    }), ': '), nhmCode) : null, productDescription ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.loading.description"
    }), ': '), productDescription) : null);
  }));
};

Loading.propTypes = {
  tour: _propTypes["default"].shape({
    additionalData: _propTypes["default"].shape({
      railInfo: _propTypes["default"].shape({
        wagonLoadings: _propTypes["default"].arrayOf(_propTypes["default"].shape())
      })
    })
  }),
  train: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    type: _propTypes["default"].number,
    coupledAssets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number
    }))
  }),
  isLoadingCoupledAssets: _propTypes["default"].bool
};
Loading.defaultProps = {
  tour: {},
  train: {
    name: ''
  },
  isLoadingCoupledAssets: false
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Loading);

exports["default"] = _default;